import { render, staticRenderFns } from "./CompetitionsDetails.vue?vue&type=template&id=6ede9d54&"
import script from "./CompetitionsDetails.vue?vue&type=script&lang=ts&"
export * from "./CompetitionsDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports